import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";

import rootReducer, { uiActions } from "../store/index";

const composeEnhancers =
	(window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
			trace: true,
			traceLimit: 25,
		})) ||
	compose;

export const store = createStore(
	rootReducer,
	composeEnhancers(applyMiddleware(thunkMiddleware)),
);

const updateNetwork = () => {
	const isOnline = window.navigator.onLine;
	store.dispatch(uiActions.setIsOnline(isOnline));
};

window.addEventListener("offline", updateNetwork);
window.addEventListener("online", updateNetwork);
